// extracted by mini-css-extract-plugin
export default {"fileDetails":"FileDetails_fileDetails__M8K3L"};